import LoginModal from "../components/Login/LoginModal";
import LoginResetPassword from "../components/Login/LoginResetPassword";
import ForgetPassword from '../components/Login/ForgetPassword';
import "../App.css";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useRef, useEffect, useState } from "react";
import * as Comp from "../common/CommonComponents";

const PAGE_NAME = "Login.js_";
const MODULE_ID = "Login";

const Login = () => {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies([]);

  const [showLogin, setShowLogin] = useState(true);
  const [showReset, setShowReset] = useState(false);
  const [showForget, setShowForget] = useState(false);
  const [resetData, setResetData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const images = importAll(require.context('../assets', false, /\.(png|jpe?g|svg)$/));

  function importAll(r) {
    let images = {};
    r.keys().map((item) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  const showHideLoginModal = () => {
    setShowLogin(!showLogin);
  };

  const showHideResetModal = () => {
    setShowReset(!showReset);
    setShowLogin(!showLogin);
  };

  const showHideForgetModal = () => {
    setShowLogin(!showLogin);
    setShowForget(!showForget);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  return (
    <>
      <LoginModal
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showLogin}
        onHide={showHideLoginModal}
        onLoading={onLoadingHandler}
        setCookies={setCookies}
        removeCookies={removeCookies}
        setResetData={setResetData}
        showHideResetModal={showHideResetModal}
        showHideForgetModal={showHideForgetModal}
        images={images}
      />

      <LoginResetPassword
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showReset}
        editData={resetData}
        onHide={showHideResetModal}
        onLoading={onLoadingHandler}
        setCookies={setCookies}
      />

      <ForgetPassword
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showForget}
        onHide={showHideForgetModal}
        onLoading={onLoadingHandler}
        setCookies={setCookies}
        removeCookies={removeCookies}
        showHideLoginModal={showHideLoginModal}
      />

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
    </>
  );
};

export default Login;
